import * as z from 'zod';

// Types
import { TitleZod } from '@/types/TitleType';
import { WaveWrapperZod } from '@/types/WaveWrapperType';
import { TagZod } from '@/types/TagType';
import { ParagraphZod } from '@/components/atoms/Paragraph/ParagraphType';

const ClientOverviewItemZod = z.object({
  id: z.number(),
  title: TitleZod,
  paragraph: ParagraphZod.nullable(),
  tags: z.array(TagZod).nullable(),
});

export type ClientOverviewItemType = z.infer<typeof ClientOverviewItemZod>;

const ClientOverviewZod = z.object({
  __component: z.literal('block.client-overview'),
  id: z.number(),
  title: TitleZod,
  main: z.array(ClientOverviewItemZod).nullable(),
  titleOverview: TitleZod,
  overview: z.array(ClientOverviewItemZod).nullable(),
  waveWrapper: WaveWrapperZod.nullable(),
});

export type ClientOverviewType = z.infer<typeof ClientOverviewZod>;

export { ClientOverviewZod, ClientOverviewItemZod };
